import React from "react";

export default function Redo() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6719 0.210327H12.3594C12.1953 0.210327 12.0312 0.37439 12.0312 0.538452C12.0312 0.565796 12.0312 0.565796 12.0312 0.565796L12.1406 2.83533C10.9102 1.35876 9.05078 0.429077 7 0.429077C3.25391 0.429077 0.191406 3.49158 0.21875 7.23767C0.21875 10.9838 3.25391 13.9916 7 13.9916C8.75 13.9916 10.3359 13.3353 11.5391 12.2689C11.5938 12.1869 11.6484 12.1049 11.6484 12.0228C11.6484 11.9135 11.5938 11.8314 11.5391 11.7767L10.6094 10.847C10.5547 10.7924 10.4727 10.765 10.3906 10.765C10.3086 10.765 10.2266 10.7924 10.1719 10.847C9.32422 11.5853 8.20312 12.0228 7 12.0228C4.32031 12.0228 2.1875 9.89001 2.1875 7.21033C2.1875 4.55798 4.32031 2.39783 7 2.39783C8.64062 2.39783 10.1172 3.24548 10.9922 4.53064L8.20312 4.39392C8.20312 4.39392 8.20312 4.39392 8.17578 4.39392C8.01172 4.39392 7.84766 4.55798 7.84766 4.72205H7.875V6.03455C7.875 6.19861 8.01172 6.36267 8.20312 6.36267H13.6719C13.8359 6.36267 14 6.19861 14 6.03455V0.538452C14 0.37439 13.8359 0.210327 13.6719 0.210327Z"
        fill="currentColor"
      />
    </svg>
  );
}
